module.exports = __webpack_public_path__ + "img/V17-bg.f495d887.png";